import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { Plan } from '../../types/plan.types';
import { useAppQuery } from '../use-app-query.hook';

type PlanProps = {
  enabled?: boolean;
  onError?: (error: HttpException | unknown) => void;
};

export const usePlans = ({ enabled, onError }: PlanProps = {}) => {
  const queryClient = useQueryClient();
  const { data: plans, isLoading } = useAppQuery<Plan[]>({
    queryKey: [QueryKey.GET_PLANS],
    queryFn: () => ApiService.get({ endpoint: BackendRoute.PLANS }),
    onError,
    enabled,
  });
  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_PLANS] });
  }, [queryClient]);
  return { plans, invalidateQuery, isLoading };
};
